import { message } from 'antd'

type Params = {
  status?: number
  onSuccess?: () => void
  onResourceFail?: () => void
  onServerFail?: () => void
}

/** Handle dựa trên lỗi HTTP request */
const requestErrorHandler = ({
  status,
  onSuccess,
  onResourceFail,
  onServerFail,
}: Params) => {
  if (status && status >= 200 && status <= 299) {
    if (typeof onSuccess === 'function') onSuccess()
  } else if (status && status >= 400 && status <= 499) {
    if (typeof onResourceFail === 'function') onResourceFail()
  } else if (status && status >= 500 && status <= 599) {
    if (typeof onServerFail === 'function') onServerFail()
  } else {
    message.error('Lỗi không xác định')
  }
}

export default requestErrorHandler
